
import PropTypes from 'prop-types'
import React from 'react'
import Link from './Link'
import './ActionText.css'

const ActionText = props => (
  <div className='ActionText'>
    <span className='ActionText-text'>{props.text} </span>
    <Link href={props.linkHref} rel={props.rel} target={props.target} onClick={props.onClick}>
      {props.linkText}
      <svg className='ActionText-arrow' width='7px' height='8px' viewBox='-1 -1 7 8'>
        <polygon stroke='none' fill='currentColor' fillRule='evenodd' transform='translate(2.500000, 3.482656) rotate(90.000000) translate(-2.500000, -3.482656)' points='2.5 0.982655502 5.9826555 5.9826555 -0.982655502 5.9826555' />
      </svg>
    </Link>
  </div>
)

ActionText.propTypes = {
  linkHref: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  rel: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.string.isRequired
}

ActionText.displayName = 'ActionText'

export default ActionText



// WEBPACK FOOTER //
// ./ui/ActionText.js